import React, {useCallback, useMemo, useState} from 'react';

import PaginationButton from './components/PaginationButton';
import PageSizeDropdown from './components/PageSizeDropdown/PageSizeDropdown';
import useCheckIsMobile from 'Shared/hooks/useCheckIsMobile';

const Pagination = (props) => {
  const {page, pageSize, onPageChange, pages, data, pageSizeOptions, onPageSizeChange} = props;
  const isMobile = useCheckIsMobile();

  const maxRangeLength = 5;
  const rangePadding = 1;

  const [rangeStart, setRangeStart] = useState(0);

  const pageLabels = useMemo(() => {
    if (pageSize > 0) {
      const rangeLength = pages > maxRangeLength ? maxRangeLength : pages;

      const rangeEnd = rangeStart + rangeLength - 1;

      if (Math.abs(page - rangeEnd) < rangePadding && rangeEnd !== pages - 1) {
        setRangeStart((rangeStart) => rangeStart + Math.abs(rangePadding - Math.abs(page - rangeEnd)));
      }

      if (Math.abs(page - rangeStart) < rangePadding && rangeStart !== 0) {
        setRangeStart((rangeStart) => rangeStart - Math.abs(rangePadding - Math.abs(page - rangeStart)));
      }
      return [...Array(rangeLength).keys()].map((el) => el + rangeStart);
    } else {
      return [];
    }
  }, [pageSize, rangeStart, maxRangeLength, pages, page, rangePadding]);

  const handlePaginationButtonClick = useCallback(
    (label) => {
      switch (label) {
        case 'left':
          if (page > 0) {
            onPageChange(page - 1);
          }
          break;

        case 'right':
          if (page < pages - 1) {
            onPageChange(page + 1);
          }
          break;

        default:
          if (label - 1 !== page) {
            onPageChange(label - 1);
          }

          break;
      }
    },
    [page, onPageChange, pages]
  );

  const itemCount = data.length;
  const fromItem = 1 + pageSize * page;
  const toItem = pageSize + pageSize * page;

  return (
    <div className="pagination">
      {
        !isMobile && (
          <PageSizeDropdown
            pageSize={pageSize}
            pageSizeOptions={pageSizeOptions}
            onPageSizeChange={onPageSizeChange}
          />
        )
      }
      <div className="pagination__labels-container" data-testid="pagination">
        <PaginationButton label="left" disabled={page === 0} onClick={handlePaginationButtonClick}/>
        {pageLabels.map((el, index) => (
          <PaginationButton
            dataTestId={'pagination-button'}
            key={index}
            label={el + 1}
            active={el === page}
            onClick={handlePaginationButtonClick}
          />
        ))}
        <PaginationButton label="right" disabled={page === pages - 1} onClick={handlePaginationButtonClick}/>
      </div>
      {
        !isMobile && (
          <div className="pagination__info">
            <p>
              {fromItem} - {toItem > itemCount ? itemCount : toItem} of
              <span className="pagination__info-total"> {itemCount}</span> entries
            </p>
          </div>
        )
      }
    </div>
  );
};

export default Pagination;
